import type { SchemadrawElement } from "../element/types";
import type { AppState, BinaryFiles } from "../utils/types";
import { exportCanvas, prepareElementsForExport } from ".";
import { getFileHandleType, isImageFileHandleType } from "./blob";

export const resaveAsImageWithScene = async (
  elements: readonly SchemadrawElement[],
  appState: AppState,
  files: BinaryFiles,
  filename: string,
) => {
  const { exportBackground, viewBackgroundColor, name, fileId, fileHandle } = appState;

  const fileHandleType = getFileHandleType(fileHandle);

  if (!fileHandle || !isImageFileHandleType(fileHandleType)) {
    throw new Error(
      "fileHandle should exist and should be of type svg or png when resaving",
    );
  }
  appState = {
    ...appState,
    exportEmbedScene: true,
  };

  const { exportedElements, exportingFrame } = prepareElementsForExport(
    elements,
    appState,
    false,
  );

  await exportCanvas(fileHandleType, exportedElements, appState, files, {
    exportBackground,
    viewBackgroundColor,
    name,
    fileId,
    fileHandle,
    exportingFrame,
  });

  return { fileHandle };
};
